module.exports = __webpack_public_path__ + "img/Nokia.96cfff40.png";